module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-FLOW-VIDEO.e11a67fd.png";